/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nav_PointsInputs */

const en_nav_points = /** @type {(inputs: Nav_PointsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Points`)
};

const es_nav_points = /** @type {(inputs: Nav_PointsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Puntos`)
};

/**
* | output |
* | --- |
* | "Points" |
*
* @param {Nav_PointsInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const nav_points = /** @type {((inputs?: Nav_PointsInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nav_PointsInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_nav_points(inputs)
	return es_nav_points(inputs)
});